import { apiRequest } from '../utils/axios';
import { FaqResponseData } from '../models/absorb/faqs';

export async function fetchFaqs(limit?: number, offset?: number): Promise<FaqResponseData> {
  return apiRequest('GET', `/faqs?limit=${limit}&_offset=${offset}`);
}
